module.exports = __webpack_public_path__ + "static/scale-model-of-escape-modesto-in-modesto-california-6fb546b56b58752c615e4efb1d370070.png";